(ns frontend.view.entity-viewers.event-pane
    (:require
     [clojure.set :as set]
     [common.features.plan :as plan]
     [common.localization :as loc]
     [common.util :as cu]
     [frontend.actions.email :as actions-email]
     [frontend.state.current-session :as session]
     [frontend.tenant-customizations :as tenant-customizations]
     [frontend.utils :as fu]
     [frontend.view.entity-viewers.activity.entity-activity :as entity-activity]
     [frontend.view.entity-viewers.activity.events :as events]
     [frontend.view.entity-viewers.components :as nev-components]
     [frontend.view.entity-viewers.events.email-editor :as email-editor]
     [frontend.view.entity-viewers.modules :as modules]
     [frontend.view.modals.activity-entity-editor.view :as activity-entity-editor]
     [frontend.view.modals.dynamic.view :as dynamic-modal]
     [frontend.view.modals.email-editor.view :as email-editor-modal]
     [frontend.view.modals.events :as modals]
     [frontend.view.modals.value-creation.view :as value-creation]
     [frontend.zap-time :as zap-time]
     [reagent.core :as r]
     [ui.components.button.view :as button]
     [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
     [ui.components.radix-ui.tooltip.view :as tooltip]
     [ui.dom-globals :as dg]))

(defn tab-elem
  [{:keys [:state
           :default-view
           :view-kw
           :kw
           :icon
           :fa-style
           :on-click!]}]
  (let [current-view (or (get @state view-kw) default-view)]
    [:span
     {:class-name (fu/cs "mb-0 flex py-2 gap-2 items-center text-sm cursor-pointer hover:text-base-light-text-accent" (and (= current-view kw) "text-base-light-text-accent border-b-2 border-solid border-base-light-border-accent"))
      :on-click   (fn [e]
                    (when-not (and on-click!
                                   (on-click!))
                      (swap! state assoc view-kw kw)
                      (swap! state dissoc :show-count)
                      (dg/prevent-and-stop e)))}

     [:i {:class-name (fu/cs (or fa-style "fal") (name icon))}]
     [:span (loc/tr kw)]]))

(def default-event-view :activity-view/tab-all)

#_(defn all-activity-types
  []
  (set/union
    #{:entity.type/note :entity.type/note-call :entity.type/note-meeting :entity.type/note-message
      :entity.type/email :entity.type/system-activity}
    (when (session/has-module-access? @session/account :module/value-creation-activity)
      #{:entity.type/value-creation})))

(defn all-activity-types
  []
  (cond-> #{}
    (session/note-activity?)    (conj :entity.type/note)
    (session/call-activity?)    (conj :entity.type/note-call)
    (session/meeting-activity?) (conj :entity.type/note-meeting)
    (session/message-activity?) (conj :entity.type/note-message)
    (session/email-activity?)   (conj :entity.type/email)
    (session/system-activity?)  (conj :entity.type/system-activity)
    (session/has-module-access? @session/account :module/value-creation-activity)
    (conj :entity.type/value-creation)))

(defn reverse-relationships
  [local-entities entity-or-id]
  (let [eid (or (:db/id entity-or-id)
                entity-or-id)
        reverse-ids (->> @local-entities
                         vals
                         (filter (fn [{:keys [common/related-entities] :as _reverse-entity}]
                                   (contains? related-entities eid)))
                         (map :db/id))]
    (when (seq reverse-ids)
      (set reverse-ids))))

(defn reverse-relationships-value-creations
  [local-entities entity-or-id]
  (let [eid (or (:db/id entity-or-id)
                entity-or-id)
        reverse-ids (->> @local-entities
                         vals
                         (filter (fn [{:keys [value-creation/parent-entity]
                                       :as   _reverse-entity}]
                                   (= parent-entity eid)))
                         (map :db/id))]
    (when (seq reverse-ids)
      (set reverse-ids))))

(defn add-activity-dropdown
  [primary-entity]
  (let [primary-entity-id (:db/id primary-entity)
        value-creation? (session/value-creation-can-be-created? primary-entity)
        open-modal (fn [entity-type]
                     (modals/open-modal! activity-entity-editor/modal-key
                                         {:new-entity-type  entity-type
                                          :viewed-entity-id (:db/id primary-entity)}))
        nylas-ok? (and (plan/available :feature/nylas-integration
                                       @session/tenant
                                       @session/role)
                       (:account/nylas-account-id @session/account)
                       (some #{(:account/nylas-status @session/account)} [nil :nylas.status/active]))
        email-active? (or (not nylas-ok?)
                          (not= :entity.type/person (:entity/type primary-entity))
                          (not (cu/blank-value? (:person/universal-email-address primary-entity))))
        send-email
        (fn [_]
          (cond
            (not (plan/available :feature/nylas-integration
                                 @session/tenant
                                 @session/role))
            (modals/open-modal!
              dynamic-modal/modal-key
              {:title               (loc/tr :feature-not-in-use)
               :render-fn           (fn [_]
                                      [email-editor/nylas-promo])
               :show-button?        false
               :custom-validator-fn (constantly false)
               :on-submit!          identity})

            (not (and (:account/nylas-account-id @session/account)
                      (some #{(:account/nylas-status @session/account)}
                            [nil :nylas.status/active])))
            (modals/open-modal!
              dynamic-modal/modal-key
              {:title               (loc/tr :account-not-connected)
               :render-fn           (fn [_]
                                      [email-editor/account-not-connected])
               :show-button?        false
               :custom-validator-fn (constantly false)
               :on-submit!          identity})

            nylas-ok?
            (do
              (modals/open-modal!
                email-editor-modal/modal-key
                {:title-text         [:span (loc/tr :mail-from)
                                      [:span
                                       (:account/nylas-email
                                        @session/account)]]
                 :entity-id          primary-entity-id
                 :to                 (:person/universal-email-address primary-entity)
                 :on-primary-submit! actions-email/*->send-email})
              true)
            :else (do (js/console.log "unhandled condition")
                      false)))]
    [dropdown-menu/view
     {:items
      (concat
       (when value-creation?
         [{:value      :add-value-creation-activity
           :label      (loc/tr :add-value-creation-activity)
           :icon-class "fal fa-coin"
           :on-click   #(modals/open-modal! value-creation/modal-key
                                            {:containing-entity-id primary-entity-id})}])
       (when (session/note-activity?)
         [{:value      :add-note
           :label      (loc/tr :add-note)
           :icon-class "fal fa-edit"
           :on-click   #(open-modal :entity.type/note)}])
       (when (session/call-activity?)
         [{:value      :log-call
           :label      (loc/tr :log-call)
           :icon-class "fal fa-phone"
           :on-click   #(open-modal :entity.type/note-call)}])
       (when (session/meeting-activity?)
         [{:value      :log-meeting
           :label      (loc/tr :log-meeting)
           :icon-class "fal fa-users"
           :on-click   #(open-modal :entity.type/note-meeting)}])
       (when (session/message-activity?)
         [{:value      :log-message
           :label      (loc/tr :log-message)
           :icon-class "fal fa-comments"
           :on-click   #(open-modal :entity.type/note-message)}])
       (when (session/email-activity?)
         [{:value      :send-email
           :disabled?  (not email-active?)
           :label      (if email-active?
                         (loc/tr :send-email)
                         [tooltip/view
                          (loc/tr :send-email)
                          (loc/tr :no-valid-email-for-this-contact)])
           :icon-class "fal fa-envelope"
           :on-click   (fn [_]
                         (when email-active?
                           (send-email nil)))}]))
      :props {:align "end"}
      :trigger-as-child
      [:span
       [:span
        {:class "hidden md:block"}
        [button/sm-secondary-hollow
         {}
         [:i.fal.fa-plus]
         (loc/tr :add-activity)]]
       [:span
        {:class "md:hidden"}
        [button/secondary-open
         {:tooltip (loc/tr :add-activity)}
         [:i.fal.fa-plus-circle]]]]}]))

(defn some-activity-has-expandable-content?
  [state]
  ; This expects that value creations always have so much data that it's expandable.
  ; This may not be always true, so adjustments may have to be made.
  (or (:visible-value-creations? @state)
      (some->> @state
               :content-height
               (vals)
               (filter (fn [height]
                         ; 75 is the limit set in activity-elem -component.
                         ; This may be subject to change
                         (< 75 height)))
               (seq))))

(defn expand-collapse-buttons
  [state]
  (let [all-expanded? (:expand-all? @state)
        collapse-all (fn [_]
                       (swap! state dissoc :expand-all? :override-expand-entity))
        expand-all (fn [_]
                     (swap! state assoc :expand-all? true)
                     (swap! state dissoc :override-expand-entity))]
    [:<>
     [:div
      {:class "hidden md:block"}
      (if all-expanded?
        [button/sm-secondary-hollow
         {:on-click collapse-all
          :tooltip  (loc/tr :collapse-all)}
         [:i.fal.fa-compress-alt]
         (loc/tr :collapse-all)]
        [button/sm-secondary-hollow
         {:on-click expand-all
          :tooltip  (loc/tr :expand-all)}
         [:i.fal.fa-expand-alt]
         (loc/tr :expand-all)])]
     [:div
      {:class "block md:hidden"}
      (if all-expanded?
        [button/square-secondary-open
         {:on-click collapse-all
          :tooltip  (loc/tr :collapse-all)}
         [:i.fal.fa-compress-alt]]
        [button/square-secondary-open
         {:on-click expand-all
          :tooltip  (loc/tr :expand-all)}
         [:i.fal.fa-expand-alt]])]]))

(defn activity-timeline-card
  [{:keys [primary-entity-id state relationship-datas-by-entity-type
           show-more! local-entities]}]
  (let [primary-entity (session/get-entity primary-entity-id)
        event-view (or (:activity-view @state) default-event-view)
        expandable-content? (some-activity-has-expandable-content? state)
        available-types (set/intersection
                         (all-activity-types)
                         (set (keys relationship-datas-by-entity-type)))
        show-all-tab? (> (count available-types) 1)
        single-tab-view (when (= (count available-types) 1)
                          (case (first available-types)
                            :entity.type/note         :activity-view/tab-notes
                            :entity.type/email        :activity-view/tab-emails
                            :entity.type/note-call    :activity-view/tab-calls
                            :entity.type/note-meeting :activity-view/tab-meetings
                            :entity.type/note-message :activity-view/tab-messages
                            :entity.type/value-creation :activity-view/tab-value-creations
                            nil))
        effective-default-view (or single-tab-view default-event-view)
        activity-params {:state        state
                         :default-view effective-default-view
                         :view-kw      :activity-view}]
    [:div
     {:class "p-4 mb-2 bg-base-light border border-solid border-base-light-border-paler rounded transition"}
     [:div
      {:class "flex justify-between items-center gap-3"}
      [:p
       {:class "font-bold"}
       (loc/tr :timeline)]
      [:div
       {:class "flex gap-2"}
       (when expandable-content?
         [expand-collapse-buttons state])
       (when (session/any-creatable-activity-access? primary-entity)
         [add-activity-dropdown primary-entity])]]
     [:div
      [:div
       [:div
        {:class "flex gap-2 border-b border-solid border-base-light-border-paler"}
        [:div
         {:class "flex items-center gap-4"}
         (when show-all-tab?
           [tab-elem
            (merge activity-params
                   {:kw   :activity-view/tab-all
                    :icon :fa-globe})])
         (when (and (:entity.type/note relationship-datas-by-entity-type)
                    (session/note-activity?))
           [tab-elem
            (merge activity-params
                   {:kw   :activity-view/tab-notes
                    :icon :fa-edit})])
         (when (and (:entity.type/email relationship-datas-by-entity-type)
                    (session/email-activity?))
           [tab-elem
            (merge activity-params
                   {:kw   :activity-view/tab-emails
                    :icon :fa-envelope})])
         (when (and (:entity.type/note-call relationship-datas-by-entity-type)
                    (session/call-activity?))
           [tab-elem
            (merge activity-params
                   {:kw   :activity-view/tab-calls
                    :icon :fa-phone})])
         (when (and (:entity.type/note-meeting relationship-datas-by-entity-type)
                    (session/meeting-activity?))
           [tab-elem
            (merge activity-params
                   {:kw   :activity-view/tab-meetings
                    :icon :fa-users})])
         (when (and (:entity.type/note-message relationship-datas-by-entity-type)
                    (session/message-activity?))
           [tab-elem
            (merge activity-params
                   {:kw   :activity-view/tab-messages
                    :icon :fa-comments})])
         
         (when (:entity.type/value-creation relationship-datas-by-entity-type)
           [tab-elem
            (merge activity-params
                   {:kw   :activity-view/tab-value-creations
                    :icon :fa-dollar-sign})])]]
       (case event-view
         :activity-view/tab-all [entity-activity/view primary-entity-id state
                                 show-more! local-entities
                                 relationship-datas-by-entity-type
                                 (all-activity-types)]
         :activity-view/tab-emails [entity-activity/view primary-entity-id state
                                    show-more! local-entities
                                    relationship-datas-by-entity-type
                                    #{:entity.type/email}]
         :activity-view/tab-notes [entity-activity/view primary-entity-id state show-more!
                                   local-entities relationship-datas-by-entity-type
                                   #{:entity.type/note}]
         :activity-view/tab-calls [entity-activity/view primary-entity-id state show-more!
                                   local-entities relationship-datas-by-entity-type
                                   #{:entity.type/note-call}]
         :activity-view/tab-meetings [entity-activity/view primary-entity-id state
                                      show-more! local-entities
                                      relationship-datas-by-entity-type
                                      #{:entity.type/note-meeting}]
         :activity-view/tab-messages [entity-activity/view primary-entity-id state
                                      show-more! local-entities
                                      relationship-datas-by-entity-type
                                      #{:entity.type/note-message}]
         :activity-view/tab-value-creations [entity-activity/view primary-entity-id state
                                             show-more! local-entities
                                             relationship-datas-by-entity-type
                                             #{:entity.type/value-creation}]
         [:div])]]]))

(defn view-component
  [args]
  (let [{:keys [entity-ids primary-entity-id]} args
        primary-entity-id (or primary-entity-id (first entity-ids))
        state (r/atom {:max-count 50})
        local-entities (r/cursor state [:entities])
        subscription-args (assoc args
                                 :state state
                                 :primary-entity-id primary-entity-id)]
    (r/create-class
      {:component-did-mount
       (fn [_]
         (swap! state assoc
                :subscribed-ids entity-ids
                :last-subscription (zap-time/now))
         (deref state)
         (events/open-history-subscription! subscription-args)
         (events/open-emails-subscription! subscription-args))
       :component-will-unmount
       (fn [_]
         (events/stop-history-subscription! state)
         (events/stop-emails-subscription! state)
         (events/stop-audit-subscription! state))
       :reagent-render
       (fn [{:keys [entity-ids primary-entity-id module-args]}]
         (let [show-more! (fn []
                            (swap! state update :show-count (fnil + 5) 20)
                            (let [not-yet-shown (- (:max-count @state) (:show-count @state))]
                              (when (> 10 not-yet-shown)
                                (swap! state update :max-count (fnil * 50) 2)
                                (events/open-history-subscription! subscription-args)
                                (events/open-emails-subscription! subscription-args))))
               primary-entity-id (or primary-entity-id (first entity-ids))
               primary-entity (get @session/entities primary-entity-id)
               primary-entity-type (:entity/type primary-entity)
               kyc-profile? (= :entity.type/kyc-profile primary-entity-type)
               tenant-kyc-profile? (= :entity.type/tenant-kyc-profile primary-entity-type)
               contract-kyc-profile? (= :entity.type/contract-kyc-profile primary-entity-type)
               relationship-datas-by-entity-type
               (->> entity-ids
                    (mapcat
                      (fn [entity-id]
                        (concat (->> (concat @(r/track session/entity-reverse-relationships entity-id)
                                             @(r/track reverse-relationships local-entities entity-id)
                                             @(r/track reverse-relationships-value-creations
                                                       local-entities
                                                       entity-id))
                                     (map (fn [related-id]
                                            [related-id entity-id]))
                                     (doall))
                                (when-not (tenant-customizations/capman?)
                                  (entity-activity/resolve-associated-people-email-ids-for-entity
                                    local-entities
                                    entity-id)))))
                    (keep (fn [[related-id eid]]
                            (let [related-entity (or (get @local-entities related-id)
                                                     (get @session/entities related-id))
                                  parent-entity (:value-creation/parent-entity related-entity)
                                  entity-type (:entity/type related-entity)]
                              (when (or (= eid parent-entity)
                                        (and
                                          (some (set (:common/related-entities related-entity))
                                                (set (conj entity-ids eid)))                          ;; not removed from reverse
                                          (some #{entity-type} (all-activity-types))
                                          (not (:common/disabled? related-entity))))
                                [(:entity/type related-entity) eid related-entity]))))
                    (group-by first))]
           [:div
            (when (and (not (or kyc-profile? tenant-kyc-profile? contract-kyc-profile?))
                       (session/tasks-access?))
              [modules/view
               {:view-id (:view-id module-args)
                :modules
                [(nev-components/tasks-module
                  {:state-atom        (:state-atom module-args)
                   :module-id         :tasks
                   :view-id           (:view-id module-args)
                   :module-label      (loc/tr :tasks)
                   :entity            (session/get-entity primary-entity-id)
                   :hide-drag-handle? true})]}])
            
            (when (or (session/any-activity-access?)
                      (session/value-creation?))
              (if-not (:timeline-loaded @state)
                [:div.entity-timeline-loading
                 [:i.fal.fa-spinner.fa-pulse.fa-2x]
                 [:span (loc/tr :updating-activity)]]
                (let [props {:state                             state
                             :show-more!                        show-more!
                             :local-entities                    local-entities
                             :primary-entity-id                 primary-entity-id
                             :relationship-datas-by-entity-type relationship-datas-by-entity-type}]
                  [activity-timeline-card props])))]))})))

(defn view
  [{:keys [entity-ids] :as args}]
  ^{:key (str entity-ids)}
  [view-component args])
